import { getApp } from 'firebase/app';
import { createCheckoutSession, getProducts, getStripePayments, Product, StripePayments } from '@invertase/firestore-stripe-payments';

let paymentsClient: StripePayments | null = null;

const getPayments = (): StripePayments => {
  if (paymentsClient) return paymentsClient;
  const app = getApp();
  paymentsClient = getStripePayments(app, {
    productsCollection: 'products',
    customersCollection: 'customers',
  });
  return paymentsClient;
};

export const fetchStripeProducts = async () => {
  const payments = getPayments();
  return getProducts(payments, { includePrices: true, activeOnly: true });
};

export const startCheckout = async (priceId: string, successUrl: string, cancelUrl: string) => {
  const payments = getPayments();
  const session = await createCheckoutSession(payments, {
    price: priceId,
    mode: 'payment',
    success_url: successUrl,
    cancel_url: cancelUrl,
  });
  if (session?.url) {
    window.location.assign(session.url);
  } else {
    throw new Error('Unable to create checkout session');
  }
};

export type StripeProductWithPrices = Product;
